// AnalyticsTracker.js — sends a GA4 page view on every route change. Renders
// nothing, and does nothing unless REACT_APP_GA_MEASUREMENT_ID is set (see
// utils/analytics.js).
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { startAnalytics, trackPageView } from '../utils/analytics';

export default function AnalyticsTracker() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    startAnalytics();
  }, []);

  useEffect(() => {
    trackPageView(pathname, search);
  }, [pathname, search]);

  return null;
}
